module.exports = __webpack_public_path__ + "media/images/front/hospitals_search/top/bg_mv_sp-49e24028b0d1996d0db0eb06c418d6a6.png";